import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";

const links = [
  { to: "/", label: "Index", num: "01" },
  { to: "/about", label: "About", num: "02" },
  { to: "/awards", label: "Awards", num: "03" },
  { to: "/speaking", label: "Speaking", num: "04" },
  { to: "/luminarc", label: "Luminarc", num: "05" },
  { to: "/insights", label: "Insights", num: "06" },
];

export default function Navigation() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [loc.pathname]);

  return (
    <header
      className={`sticky top-0 z-40 transition-colors duration-300 ${
        scrolled
          ? "bg-[var(--cream)]/90 backdrop-blur-md border-b border-[var(--ink)]/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" className="flex items-baseline gap-2 group">
          <span className="font-mono text-[0.62rem] uppercase tracking-[0.18em] text-[var(--molten)] mr-0.5 self-center">Dr.</span>
          <span style={{ fontFamily: "Inter", fontWeight: 800, letterSpacing: "-0.04em", fontSize: "1.35rem" }}>
            Drijesh
          </span>
          <span className="italic-serif text-[var(--molten)]" style={{ fontSize: "1.05rem" }}>
            Ppatel
          </span>
          <span className="hidden md:inline-block w-2 h-2 bg-[var(--molten)] rounded-full ml-1" />
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              className={({ isActive }) =>
                `relative px-3 py-2 font-mono text-[0.68rem] uppercase tracking-[0.18em] transition-colors ${
                  isActive ? "text-[var(--ink)]" : "text-[var(--ink)]/55 hover:text-[var(--ink)]"
                }`
              }
            >
              {({ isActive }) => (
                <span className="inline-flex items-center gap-1.5">
                  <span className="text-[0.58rem] text-[var(--mute)]">{l.num}</span>
                  {l.label}
                  {isActive && <span className="absolute left-3 right-3 -bottom-0.5 h-[2px] bg-[var(--molten)]" />}
                </span>
              )}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:block">
          <Link to="/contact" className="btn-ink">
            Work with me <ArrowUpRight size={14} />
          </Link>
        </div>

        <button
          aria-label="Toggle menu"
          className="md:hidden w-10 h-10 inline-flex items-center justify-center border border-[var(--ink)]/20"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[var(--ink)]/10 bg-[var(--cream)]">
          <div className="px-6 py-4 flex flex-col">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                className={({ isActive }) =>
                  `py-3 border-b border-[var(--ink)]/10 flex items-center justify-between ${
                    isActive ? "text-[var(--molten)]" : "text-[var(--ink)]/80"
                  }`
                }
              >
                <span className="font-mono text-xs uppercase tracking-[0.18em]">
                  <span className="text-[var(--mute)] mr-2">{l.num}</span>
                  {l.label}
                </span>
                <ArrowUpRight size={14} />
              </NavLink>
            ))}
            <Link to="/contact" className="btn-ink mt-5 w-fit">
              Work with me <ArrowUpRight size={14} />
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
